import { AskScope } from '../api';
import { withChatDirectives } from './withAskDirectives';

/** The gateway validates `prompt` at 1-4000 characters; over is a rejected request. */
export const ASK_PROMPT_MAX_CHARS = 4000;

/** Rounded down to a whole hundred, so the composer shows a limit rather than a remainder. */
const LIMIT_GRANULARITY = 100;

/**
 * How much of the prompt budget is left for the user's own words.
 *
 * The directives ride along on the prompt itself (the gateway takes no system field), so they
 * spend the same 4000 characters the question does — around 1100 of them. Derived rather than
 * hard-coded because the card-link directive grows when the scope carries a channel slug, and
 * the language directive changes with the UI language: a fixed number would drift into
 * rejected requests the next time either is edited.
 *
 * Exact, not an estimate: `withChatDirectives` appends with a join, so the cost of the
 * directives is the length of `withChatDirectives('', scope)`. The panel is the only
 * surface with a composer, so the chat set is the one that has to be paid for here.
 */
export function askPromptLimit(scope: AskScope | undefined): number {
  const directiveChars = withChatDirectives('', scope ?? { type: 'org' }).length;
  const room = ASK_PROMPT_MAX_CHARS - directiveChars;
  return Math.floor(room / LIMIT_GRANULARITY) * LIMIT_GRANULARITY;
}
